<template>
  <div class='home'>
    <BranchList
      v-show='listView'
      @newBranch='onClickNewFromList'
      @editBranch='onClickEditFromList'
      :scroll="corY" ref='refreshList'
    />
    <BranchForm v-show='formView' :branch='branch' @backClicked='onBackChild' />
  </div>
</template>

<script>
// @ is an alias to /src
import BranchList from '@/components/branch/BranchList.vue'
import BranchForm from '@/components/branch/BranchForm.vue'

export default {
  name: 'Branch',
  components: {
    BranchList,
    BranchForm
  },
  data () {
    return {
      corX: 0,
      corY: 0,
      listView: true,
      formView: false,
      branch: {
        id: null,
        branch_no: null,
        org_id: null,
        name: null,
        address: null,
        phone: null,
        email: null
      }
    }
  },
  methods: {
    onClickEditFromList: function (value) {
      var x = window.pageXOffset
      var y = window.pageYOffset
      this.corX = x
      this.corY = y
      window.scrollTo(0, 0)
      this.listView = false
      this.formView = true
      this.branch = value
    },
    onClickNewFromList: function () {
      var x = window.pageXOffset
      var y = window.pageYOffset
      this.corX = x
      this.corY = y
      window.scrollTo(0, 0)
      this.listView = false
      this.formView = true
      this.branch = {
        id: null,
        branch_no: null,
        org_id: null,
        name: null,
        address: null,
        phone: null,
        email: null
      }
    },
    async onBackChild () {
      window.scrollTo(this.corX, this.corY)
      this.listView = true
      this.formView = false
      this.branch = {
        id: null,
        branch_no: null,
        org_id: null,
        name: null,
        address: null,
        phone: null,
        email: null
      }
      await this.$refs.refreshList.refreshList()
      await window.scrollTo(this.corX, this.corY)
      console.log('window.scrollTo:' + this.corY)
    }
  },
  mounted () {
    this.$store.dispatch('getOrganizationList')
  }
}
</script>
